import { useQuery } from '@apollo/client';

import { graphql } from '@eluve/graphql.tada';
import { formatHumanName } from '@eluve/utils';

const userInfoFragment = graphql(`
  fragment UserInfoFragment on Users @_unmask {
    __typename
    id
    firstName
    lastName
    email
  }
`);

const getUserNameQuery = graphql(
  `
    query getUserName($userId: uuid!) {
      usersByPk(id: $userId) {
        ...UserInfoFragment
      }
    }
  `,
  [userInfoFragment],
);

export const useUserName = (userId: string, placeholder?: string) => {
  const { data, loading } = useQuery(getUserNameQuery, {
    fetchPolicy: 'cache-first',
    variables: { userId },
    skip: userId === '',
  });

  if (loading) {
    return '...';
  }

  const userInfo = data?.usersByPk ?? null;

  if (!userInfo) {
    return placeholder ?? 'unknown user';
  }

  if (userInfo.firstName || userInfo.lastName) {
    return formatHumanName(userInfo.firstName, userInfo.lastName);
  }

  return userInfo.email;
};
